import { render } from "./SideNavbarForSmallComponent.vue?vue&type=template&id=c0c1c418"
import script from "./SideNavbarForSmallComponent.vue?vue&type=script&lang=js"
export * from "./SideNavbarForSmallComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__